import { BookingStatus } from '../types';

type Lang = 'vi' | 'en';

const STATUS_LABELS_VI: Record<string, string> = {
  [BookingStatus.PENDING_CONFIRMATION]: 'Chờ xác nhận',
  [BookingStatus.CONFIRMED]: 'Đã xác nhận',
  DEPOSIT_COLLECTED: 'Đã thu cọc',
  IN_PROGRESS: 'Đang diễn ra',
  DEPOSIT_REFUNDED: 'Đã hoàn cọc',
  [BookingStatus.AWAITING_COMPLETION]: 'Chờ kết thúc',
  [BookingStatus.COMPLETED]: 'Hoàn thành',
  [BookingStatus.PENDING_CANCELLATION]: 'Chờ hủy',
  [BookingStatus.CANCELLED]: 'Đã hủy',
};

const STATUS_LABELS_EN: Record<string, string> = {
  [BookingStatus.PENDING_CONFIRMATION]: 'Pending Confirmation',
  [BookingStatus.CONFIRMED]: 'Confirmed',
  DEPOSIT_COLLECTED: 'Deposit Collected',
  IN_PROGRESS: 'In Progress',
  DEPOSIT_REFUNDED: 'Deposit Refunded',
  [BookingStatus.AWAITING_COMPLETION]: 'Awaiting Completion',
  [BookingStatus.COMPLETED]: 'Completed',
  [BookingStatus.PENDING_CANCELLATION]: 'Pending Cancellation',
  [BookingStatus.CANCELLED]: 'Cancelled',
};

const STATUS_COLORS: Record<string, string> = {
  [BookingStatus.PENDING_CONFIRMATION]: 'bg-yellow-100 text-yellow-800',
  [BookingStatus.CONFIRMED]: 'bg-blue-100 text-blue-800',
  DEPOSIT_COLLECTED: 'bg-cyan-100 text-cyan-800',
  IN_PROGRESS: 'bg-purple-100 text-purple-800',
  DEPOSIT_REFUNDED: 'bg-indigo-100 text-indigo-800',
  [BookingStatus.AWAITING_COMPLETION]: 'bg-blue-100 text-blue-800',
  [BookingStatus.COMPLETED]: 'bg-green-100 text-green-800',
  [BookingStatus.PENDING_CANCELLATION]: 'bg-orange-100 text-orange-800',
  [BookingStatus.CANCELLED]: 'bg-gray-100 text-gray-800',
};

export function getUtilityBookingStatusLabel(status: string, lang: Lang = 'vi'): string {
  const labels = lang === 'en' ? STATUS_LABELS_EN : STATUS_LABELS_VI;
  return labels[status] || status;
}

export function getUtilityBookingStatusColor(status: string): string {
  return STATUS_COLORS[status] || STATUS_COLORS[BookingStatus.PENDING_CONFIRMATION];
}
